module.exports = __webpack_public_path__ + "img/packages/top_row_mobile.294124.png";